module.exports = __webpack_public_path__ + "img/XT3.2270290e.png";